/**
 * Dashboard layout sync status shared by the layout service.
 */
export function getSyncStatus(hasPendingChanges: boolean): 'synced' | 'pending' | 'offline' {
  if (!navigator.onLine) return 'offline';
  return hasPendingChanges ? 'pending' : 'synced';
}
